"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=corporate-credit-policy.dto.js.map